import React from "react";
import OffertTextENG from "./offert-text/offert-text-eng"
import OffertTextKAZ from "./offert-text/offert-text-kaz";
import OffertTextRUS from "./offert-text/offert-text-rus";
import s from "./offerts.module.scss"

const Offert = (props) => {

    const getOffertText = (lang) => {
        switch(lang){
            case 'RUS':
                return <OffertTextRUS />
            case 'KAZ':
                return <OffertTextKAZ />
            case 'ENG': 
                return <OffertTextENG />
            default:
                return <OffertTextRUS />
        }
    }

    const text = getOffertText(props.selectedLanguage)

    return (
        <div className={s.Offert}>
            <div className={s.content}>
                <h1>{props.getValue("OFFERT")}</h1>
                { text }
            </div>
            
        </div>
    )
}

export default Offert;